import React from 'react';
import { Flex, Typography } from 'antd';
import {
  IdcardOutlined,
  SafetyCertificateOutlined,
  MobileOutlined,
  CheckCircleOutlined,
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const { Title, Paragraph } = Typography;

const STEPS = [
  {
    icon: <IdcardOutlined style={{ fontSize: 28, color: '#6B35D4' }} />,
    step: '01',
    title: 'Enter Aadhaar',
    desc: 'Provide your 12-digit Aadhaar number to begin the verification process securely.',
  },
  {
    icon: <SafetyCertificateOutlined style={{ fontSize: 28, color: '#6B35D4' }} />,
    step: '02',
    title: 'Verify OTP',
    desc: 'Enter the one-time password sent to your Aadhaar-linked mobile number.',
  },
  {
    icon: <MobileOutlined style={{ fontSize: 28, color: '#6B35D4' }} />,
    step: '03',
    title: 'Confirm Mobile',
    desc: 'Verify your mobile number with another OTP for secure account linkage.',
  },
  {
    icon: <CheckCircleOutlined style={{ fontSize: 28, color: '#12B76A' }} />,
    step: '04',
    title: 'Get Your ABHA ID',
    desc: 'Choose your preferred ABHA address and your health ID is instantly created!',
  },
];

const HowToCreate = () => {
  const navigate = useNavigate();

  return (
    <section id="how-to" className="section-padding bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <div
            className="inline-block px-4 py-1 rounded-full text-xs font-bold tracking-widest mb-4"
            style={{ background: '#f0eaff', color: '#6B35D4', letterSpacing: '0.1em' }}
          >
            SIMPLE PROCESS
          </div>
          <Title level={2} className="mb-4" style={{ color: '#1a1a2e' }}>
            How to Create Your ABHA ID
          </Title>
          <Paragraph
            className="mx-auto"
            style={{ color: '#666', fontSize: 16, maxWidth: 520, lineHeight: 1.75 }}
          >
            Get your ABHA Health ID in under 3 minutes. Follow these simple steps and join
            55 crore+ Indians on the digital health network.
          </Paragraph>
        </div>

        {/* Steps grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {STEPS.map((s, i) => (
            <div
              key={s.step}
              className="hover-lift relative"
              style={{
                background: '#fafbff',
                border: '1px solid #f0eaff',
                borderRadius: 16,
                padding: 28,
                cursor: 'default',
              }}
            >
              {/* Connector line */}
              {i < STEPS.length - 1 && (
                <div
                  className="hidden lg:block absolute top-12 right-0 translate-x-1/2"
                  style={{
                    width: 24,
                    height: 2,
                    background: 'linear-gradient(90deg, #e0d6ff, #6B35D4)',
                    zIndex: 1,
                  }}
                />
              )}
              <div
                className="text-xs font-black mb-4 tracking-widest"
                style={{ color: '#c4a0ff' }}
              >
                {s.step}
              </div>
              <div
                className="flex items-center justify-center rounded-2xl mb-5"
                style={{
                  width: 56,
                  height: 56,
                  background: '#f0eaff',
                }}
              >
                {s.icon}
              </div>
              <h3 className="font-bold text-base mb-2" style={{ color: '#1a1a2e' }}>
                {s.title}
              </h3>
              <p className="text-sm leading-relaxed" style={{ color: '#666' }}>
                {s.desc}
              </p>
            </div>
          ))}
        </div>

        {/* CTA */}
        <Flex justify="center" className="mt-12">
          <button
            onClick={() => navigate('/create-abha')}
            className="btn-pink px-8 py-3 rounded-xl text-base font-bold cursor-pointer"
            style={{ border: 'none', color: '#fff' }}
          >
            + Create ABHA for Free
          </button>
        </Flex>
      </div>
    </section>
  );
};

export default HowToCreate;
